export default __webpack_public_path__ + "static/ring-4b2c054232b0de195c7bdb0fa77673a7.png";